module.exports = __webpack_public_path__ + "img/curvinha-fill.af9739c4.svg";